import { css } from "@emotion/css";
import { theme } from "../../utils/theme";

export const agentMessageContentCSS = css`
  color: ${theme.palette["katana-black"]};
  max-width: 100%;

  .markdown-content {
    em {
      font-style: unset;
    }

    p,
    li,
    h1 {
      color: ${theme.palette["katana-black"]};
    }

    li {
      margin-top: 0;
    }

    h1 {
      display: none;
      font-size: 32px;
      padding: 0;
      line-height: 32px;
      margin: 0 0 1rem 0;
    }

    // @TODO: adjust this if "chat-ai-dialog" class is removed
    .chat-ai-dialog & .markdown-content {
      h1 {
        font-size: 20px;
        line-height: 20px;
      }
    }
  }
`;
